import { render } from "./Costs.vue?vue&type=template&id=7b283b09"
import script from "./Costs.vue?vue&type=script&lang=js"
export * from "./Costs.vue?vue&type=script&lang=js"

import "./Costs.vue?vue&type=style&index=0&id=7b283b09&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__